module.exports = __webpack_public_path__ + "static/media/icon_newsletter--success.1ae7008d.svg";